import { createStructuredSelector } from 'reselect'

import {
  EVALUATION_USER_LIST,
  EVALUATION_USER_LIST_SUCCESS, 
  EVALUATION_USER_LIST_ERROR,
  EVALUATION_USER_PAGE_SET,
  EVALUATION_USER_SEARCH_SET,
  EVALUATION_USER_SEARCH_CHANGE,
  EVALUATION_USER_SEARCH_EVALUATION_ROLE,
  EVALUATION_USER_SEARCH_EVALUATION_ROLE_SUCCESS,
  EVALUATION_USER_SEARCH_EVALUATION_ROLE_ERROR, 
  EVALUATION_USER_SEARCH_USER,
  EVALUATION_USER_SEARCH_USER_SUCCESS,
  EVALUATION_USER_SEARCH_USER_ERROR, 
  EVALUATION_USER_ADD_SET,
  EVALUATION_USER_ADD_MODAL_SET,
  EVALUATION_USER_ADD,
  EVALUATION_USER_ADD_SUCCESS,
  EVALUATION_USER_ADD_ERROR,
  EVALUATION_USER_ADD_CHANGE,
  EVALUATION_USER_DETAIL,
  EVALUATION_USER_DETAIL_SUCCESS,
  EVALUATION_USER_DETAIL_ERROR,
  EVALUATION_USER_VIEW_MODAL_SET,
  EVALUATION_USER_EDIT_CHANGE,
  EVALUATION_USER_EDIT_MODAL_SET,
  EVALUATION_USER_UPDATE,
  EVALUATION_USER_UPDATE_SUCCESS,
  EVALUATION_USER_UPDATE_ERROR,
  EVALUATION_USER_VIEW_TAB_SET,
  EVALUATION_USER_UPLOAD_SET,
  EVALUATION_USER_UPLOAD_SET_SUCCESS,
  EVALUATION_USER_UPLOAD_SET_ERROR,
  EVALUATION_USER_UPLOAD_RESET
} from '../../actions';

export const NAME = 'evaluation_user';

export const EvaluationUserList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EVALUATION_USER_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EvaluationUserListSuccess = (data) => ({
  type: EVALUATION_USER_LIST_SUCCESS,
  payload: data
});

export const EvaluationUserListError = (error) => ({
  type: EVALUATION_USER_LIST_ERROR,
  payload: error
});

export const EvaluationUserPageSet = (data) => ({
  type: EVALUATION_USER_PAGE_SET,
  payload: data
});

export const EvaluationUserSearchSet = (data) => ({
  type: EVALUATION_USER_SEARCH_SET,
  payload: data
});

export const EvaluationUserSearchChangeSet = (data) => ({
  type: EVALUATION_USER_SEARCH_CHANGE,
  payload: data
});

export const EvaluationUserSearchUser = (data) => ({
  type: EVALUATION_USER_SEARCH_USER,
  payload: data
});

export const EvaluationUserSearchUserSuccess = (message) => ({
  type: EVALUATION_USER_SEARCH_USER_SUCCESS,
  payload: message
});

export const EvaluationUserSearchUserError = (error) => ({
  type: EVALUATION_USER_SEARCH_USER_ERROR,
  payload: error
}); 

export const EvaluationUserSearchEvaluationRole = (data) => ({
  type: EVALUATION_USER_SEARCH_EVALUATION_ROLE,
  payload: data
});

export const EvaluationUserSearchEvaluationRoleSuccess = (message) => ({
  type: EVALUATION_USER_SEARCH_EVALUATION_ROLE_SUCCESS,
  payload: message
});

export const EvaluationUserSearchEvaluationRoleError = (error) => ({
  type: EVALUATION_USER_SEARCH_EVALUATION_ROLE_ERROR,
  payload: error
}); 

export const EvaluationUserAddChangeSet = (data) => ({
  type: EVALUATION_USER_ADD_CHANGE,
  payload: data
});

export const EvaluationUserAddSet = (data) => ({
  type: EVALUATION_USER_ADD_SET,
  payload: data
});

export const EvaluationUserAddModalSet = (data) => ({
  type: EVALUATION_USER_ADD_MODAL_SET,
  payload: data
});

export const EvaluationUserAdd = (data) => ({
  type: EVALUATION_USER_ADD,
  payload: data
});

export const EvaluationUserAddSuccess = (message) => ({
  type: EVALUATION_USER_ADD_SUCCESS,
  payload: message
});

export const EvaluationUserAddError = (error) => ({
  type: EVALUATION_USER_ADD_ERROR,
  payload: error
});

export const EvaluationUserDetail = (data) => ({
  type: EVALUATION_USER_DETAIL,
  payload: data
});

export const EvaluationUserDetailSuccess = (data) => ({
  type: EVALUATION_USER_DETAIL_SUCCESS,
  payload: data
});

export const EvaluationUserDetailError = (error) => ({
  type: EVALUATION_USER_DETAIL_ERROR,
  payload: error
});

export const EvaluationUserViewModalSet = (data) => ({
  type: EVALUATION_USER_VIEW_MODAL_SET,
  payload: data
});

export const EvaluationUserEditModalSet = (data) => ({
  type: EVALUATION_USER_EDIT_MODAL_SET,
  payload: data
});

export const EvaluationUserEditChangeSet = (data) => ({
  type: EVALUATION_USER_EDIT_CHANGE,
  payload: data
});

export const EvaluationUserUpdate = (data) => ({
  type: EVALUATION_USER_UPDATE,
  payload: data
});

export const EvaluationUserUpdateSuccess = (message) => ({
  type: EVALUATION_USER_UPDATE_SUCCESS,
  payload: message.message
});

export const EvaluationUserUpdateError = (error) => ({
  type: EVALUATION_USER_UPDATE_ERROR,
  payload: error
});

export const EvaluationUserViewTabSet = (data) => ({
  type: EVALUATION_USER_VIEW_TAB_SET,
  payload: data
});

export const EvaluationUserUploadSet = (file) => ({
  type: EVALUATION_USER_UPLOAD_SET,
  payload: { file },
});

export const EvaluationUserUploadSetSuccess = (items) => ({
  type: EVALUATION_USER_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const EvaluationUserUploadSetError = (error) => ({
  type: EVALUATION_USER_UPLOAD_SET_ERROR,
  payload: error,
});

export const EvaluationUserUploadReset= () => ({
  type: EVALUATION_USER_UPLOAD_RESET
});

const evaluation_user = (state) => state[NAME];

export const EvaluationUserSelector = createStructuredSelector({
  evaluation_user
})
 